export const environment = {
  production: true,
  GA_TRACKING_ID: 'UA-186920304-1'
};
